/* eslint-disable */
// tslint:disable
/**
 * Isletnet API
 *  # Islets  Rest API for [IsletNet](http://isletnet.com/) - an accurate neural network based tool for automated segmentation and analysis  of pancreatic (Langerhans) islets. For more information, see the IsletNet [User guide](http://isletnet.com/guide) or try the tool at  [www.isletnet.com](http://isletnet.com/).  Both IsletNet and this API serve for two main usecases:  ## Analysis   The main usecase.   User submits a request:   - images of the tissue AND/OR own segmentations (can be mixed) - user input data (information about batch of images)   The API returns the response containing: - automated segmentation of islets for each submitted image of the tissue  - histogram of islet size distribution for each image - results of the analysis (both detailed results per image and overall summary)  ## Validation  The usecase to assess the accuracy of one\'s own segmentation by submitting both the segmentation and the  original image. The API returns the comparison of his segmentation to the automated one, returning both  visual and statistical summary.  User submits a request:  - image&own_segmentation (mask) pairs  The API returns the response containing: - results of validation against the automated segmentation - visual comparison 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MaskStatistics
 */
export interface MaskStatistics {
    /**
     * 
     * @type {number}
     * @memberof MaskStatistics
     */
    ieEllipse: number;
    /**
     * 
     * @type {number}
     * @memberof MaskStatistics
     */
    ieSphere: number;
    /**
     * 
     * @type {number}
     * @memberof MaskStatistics
     */
    ieSpinacle?: number;
    /**
     * 
     * @type {number}
     * @memberof MaskStatistics
     */
    ieTable: number;
    /**
     * 
     * @type {number}
     * @memberof MaskStatistics
     */
    isletCount: number;
    /**
     * 
     * @type {number}
     * @memberof MaskStatistics
     */
    purity: number;
}

export function MaskStatisticsFromJSON(json: any): MaskStatistics {
    return MaskStatisticsFromJSONTyped(json, false);
}

export function MaskStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaskStatistics {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ieEllipse': json['ie_ellipse'],
        'ieSphere': json['ie_sphere'],
        'ieSpinacle': !exists(json, 'ie_spinacle') ? undefined : json['ie_spinacle'],
        'ieTable': json['ie_table'],
        'isletCount': json['islet_count'],
        'purity': json['purity'],
    };
}

export function MaskStatisticsToJSON(value?: MaskStatistics | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ie_ellipse': value.ieEllipse,
        'ie_sphere': value.ieSphere,
        'ie_spinacle': value.ieSpinacle,
        'ie_table': value.ieTable,
        'islet_count': value.isletCount,
        'purity': value.purity,
    };
}


